"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveMyAssignationsDataOptions = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
let RetrieveMyAssignationsDataOptions = class RetrieveMyAssignationsDataOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
};
exports.RetrieveMyAssignationsDataOptions = RetrieveMyAssignationsDataOptions;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveMyAssignationsDataOptions.prototype, "periodIndex", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveMyAssignationsDataOptions.prototype, "userIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveMyAssignationsDataOptions.prototype, "statusIn", void 0);
exports.RetrieveMyAssignationsDataOptions = RetrieveMyAssignationsDataOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveMyAssignationsDataOptions);
//# sourceMappingURL=RetrieveMyAssignationsDataOptions.js.map